'use client';

import ImageOptimizer from '@/components/image-optimizer';
import { LicenseIntroductionData } from '@/data/academy.price.data';

interface LicenseIntroductionProps {
  data: LicenseIntroductionData;
}

export default function LicenseIntroduction({
  data,
}: LicenseIntroductionProps) {
  const { title, mainImage, description, drivableVehicles, qualifications } =
    data;

  return (
    <section className="px-5 py-8 bg-white">
      <h2 className="typo-20 font-extrabold text-222222 mb-4">{title}</h2>

      <div className="mb-4 relative aspect-[320/120] w-full">
        <ImageOptimizer
          src={mainImage}
          alt={title}
          width={320}
          height={120}
          className="w-full h-auto object-cover"
        />
      </div>

      <p className="typo-14 font-bold text-[#4F4F5E] leading-normal mb-7">
        {description}
      </p>

      <div className="mb-7">
        <h3 className="typo-16 font-extrabold text-333333 mb-5">
          운전가능 차량
        </h3>
        <div className="flex flex-wrap gap-x-6 gap-y-4 justify-start">
          {drivableVehicles.map((vehicle, index) => (
            <div
              key={`${vehicle.car}-${index}`}
              className="flex flex-col items-center"
            >
              <div className="rounded-full bg-[#F5F5FA] relative h-[40px] w-[40px] flex items-center justify-center mb-3">
                <ImageOptimizer
                  src={vehicle.icon}
                  alt={vehicle.car}
                  width={24}
                  height={24}
                  className="object-contain"
                />
              </div>
              <div className="flex flex-col items-center gap-1">
                <span className="typo-14 font-bold text-[#4D4D4D] text-center">
                  {vehicle.car}
                </span>
                <span className="typo-12 font-medium text-[#908E9E] text-center">
                  {vehicle.desc}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="typo-16 font-extrabold text-333333 mb-4">응시 자격</h3>
        <ul className="space-y-2">
          {qualifications.map((item, index) => (
            <li
              key={`qualification-${index}`}
              className="typo-14 font-semibold text-[#4F4F5E] flex items-start "
            >
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
